import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import TableDiscountList from './TableDiscountList'
import { AppState } from '../../reducers'
import { Stack } from '@mui/material'
import { DiscountListState } from '../../reducers/discountList'
import { fetchDiscountList } from '../../actions/discountList'

interface Props {
  discountList: DiscountListState
}

const DiscountList: React.FC<Props> = ({ discountList }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchDiscountList())
  }, [dispatch])
  
  return (
    <Stack style={{ height: 'calc(100% - var(--header-height)' }}>

      <TableDiscountList
        rows={(discountList.discountList || []).map(s => ({ data: s }))}
        loading={discountList.isFetching}
        fullInfo={false}
        adminInfo={false}
      />
      {/*
      <Stack display="flex" flexDirection='row' justifyContent="space-between" padding="10px">
        <Button aria-label="download" size='large' style={{ textTransform: 'none' }}
          href={`${process.env.REACT_APP_API_URL}/dlDiscountList?access_token=${getToken()}`} target="_blank">
          {t('downloadDL')}
        </Button>
      </Stack>*/}
    </Stack>

  )
}

const mapStateToProps = (state: AppState) => ({
  discountList: state.discountList
})

export default connect(mapStateToProps, null)(DiscountList)